import { Box, SxProps, Theme } from '@mui/material'

import usePartnerCentralized from '~/features/partners/hooks/usePartnerCentralized'
import { ESiteImagesTypes } from '~/features/partners/models'
import { getImgUrlByType, isLibbyDomain } from '~/features/partners/utils'

type TProps = {
  sx?: SxProps<Theme>
}
function AuthFormsLogo({ sx = {} }: TProps) {
  const isPartner = !isLibbyDomain()
  const { partner } = usePartnerCentralized()
  const logoSrc = getImgUrlByType(ESiteImagesTypes.logoDark, partner)

  return (
    isPartner &&
    logoSrc && (
      <Box
        component="img"
        src={logoSrc}
        alt="Logo"
        width={150}
        sx={{
          alignSelf: 'center',
          ...sx,
        }}
      />
    )
  )
}

export default AuthFormsLogo
